import React, { memo } from 'react'

import { Link } from 'react-router-dom'

import { Icon, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  bool, elementType, func, string,
} from 'prop-types'

import { iconSizeNav } from 'Pods/ThreeDStudio/constants'

import { NOOP } from 'Utils/stableDefaults'

function SubNavItem({
  to,
  label,
  icon,
  isActive = false,
  withRail = true,
  onClick = NOOP,
  onMouseEnter = NOOP,
  onFocus = NOOP,
}) {
  return (
    <Link
      to={to}
      className={classnames(
        'sub-nav-item',
        isActive ? 'cgt-body-base-semibold' : 'cgt-body-base',
        isActive && 'sub-nav-item--active',
        withRail && 'sub-nav-item--railed',
      )}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onFocus={onFocus}
    >
      {withRail && <span className="sub-nav-item__rail" aria-hidden="true" />}
      <Icon
        svgComponent={icon}
        size={iconSizeNav}
        color={isActive ? 'primary' : 'darker'}
        notSpaced
      />
      <span>{label}</span>
    </Link>
  )
}

SubNavItem.propTypes = {
  to: string.isRequired,
  label: string.isRequired,
  icon: elementType.isRequired,
  isActive: bool,
  withRail: bool,
  onClick: func,
  onMouseEnter: func,
  onFocus: func,
}

export default memo(SubNavItem)
